export default __webpack_public_path__ + "static/media/AcerJal_Jason.0632031c.png";